export default "__VITE_ASSET__Cg134amf__"